export const dateAddDay = (date: Date, addDay: number, operator: '+' | '-' = '+'): Date => {
    const newDate = new Date(date);
    operator === '+' ? newDate.setDate(newDate.getDate() + addDay) : newDate.setDate(newDate.getDate() - addDay);
    return newDate;
}

